import { Platform } from 'react-native';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export const useReactNavigationFlag = () => {
  const enableReactNavigation = useFlag(LaunchDarklyFlag.ENABLE_REACT_NATIVE_NAVIGATION);
  return Platform.OS !== 'web' && enableReactNavigation;
};
